<template>
  <div>
    <div class="container page-body">
      <div class="general-panel">
        <div class="general-panel__header general-panel--orange">
          <h5 class="general-panel__header-text">
            <i class="general-panel__header-icon fas fa-cloud-upload-alt"></i>
            Uploads: {{ numberImages }} <span class="text-smaller-2">of</span>
            {{ maxNumUploads }}
            <span class="text-smaller-2">max</span>
          </h5>
        </div>

        <ToggleControl
          toggle-id="list-desc"
          closed-text="About this list"
          open-text="- hide -"
          toggle-class="general-panel__toggle-pane general-panel--orange"
        >
          <template v-slot:default="slotProps">
            {{ slotProps.togglerText.display }}
          </template>
        </ToggleControl>

        <!-- <div
          v-b-toggle.list-desc
          class="general-panel general-panel__toggle-pane general-panel--orange general-panel--focus-off"
        >
          <i class="fas" :class="aboutPaneIconClass"></i> {{ aboutPanelText }}
        </div> -->
        <div class="general-panel__content">
          <b-collapse id="list-desc">
            <div class="general-panel__row general-panel__row--standard-text">
              <p class="font-weight-bold mb-1">Uploads List Overview</p>
              <p>
                When you upload an image, the image and the text you entered
                with it appear in this list. An image in this list can and may
                eventually be evaluated by us for inclusion in a book or
                calendar.
              </p>
              <p>
                The number in the orange button above and in the header of this
                text block is how many images are in this list:
                <strong>{{ numberImages }}</strong>
              </p>
              <p>
                When we're choosing images for a book or calendar project, we
                look here in the <strong>Uploads</strong> list of our users. In
                general, we select 40 - 60 images for each project, selecting
                one (1) image each from as many users.
              </p>
              <p>
                We analyze images one by one and either
                <strong>Select</strong> the image for a project or determine
                that the image is <strong>Unusable</strong>.
              </p>
              <p>
                When we <strong>Select</strong> an image for a project, we mark
                it <span class="italic">Selected</span>; it will no longer
                appear in this Uploads list. Instead, it will appear in your
                <strong>Selected</strong> list (click the blue button above to
                see that list).
              </p>
              <p>
                If we mark an image as <strong>Unusable</strong>, it will no
                longer appear in this Uploads list. Instead, it will show in
                your <strong>Unusable</strong> list (click the red button above
                to see that list).
              </p>

              <p class="font-weight-bold mb-1">Editing/Deleting Images</p>
              <p>
                You can edit or delete any image in this Uploads list - images
                in the other lists cannot be edited or deleted. Editing means
                you can change any of the text content and/or replace the image.
              </p>
              <p class="font-weight-bold mb-1">Managing Your Uploads</p>
              <p>
                As you can see in your Images Summary panel above,
                <strong
                  >you can have at most {{ maxNumUploads }} images in this
                  list</strong
                >. When you reach the max number, all of your upload slots are
                filled. You cannot upload another image until a slot becomes
                available.
              </p>
              <p>
                A slot becomes available when you delete an image, or when we
                mark an image as Selected or Unusable.
              </p>
              <p>
                As long as you have an Upload Slot available, you can upload an
                image, which means:
                <strong
                  >There is no limit to the number of images you can
                  upload!</strong
                >
              </p>
              <p>
                <strong>Please note:</strong> It's completely up to you but we
                recommend no matter how many images you have in your Uploads
                list, you <strong>KEEP</strong> them there! The more images
                uploaded, the greater the chance any/all of your images will end
                up in books and calendars, and therefore, the more dogs we all
                can help find loving homes!
              </p>
              <!-- <button @click="rerenderView">Rerender this view</button> -->
            </div>
          </b-collapse>
          <div class="general-panel__row general-panel__row--3col">
            <transition-group tag="div" name="list">
              <CardImage
                v-for="image in images"
                :key="image.id"
                :image="image"
                :type="type"
                :showHeader="showHeader"
                :showButtonPanel="showButtonPanel"
                :showProductsPanel="showProductsPanel"
                @delete-clicked="showConfirmDelete($event)"
              />
            </transition-group>
          </div>
        </div>
      </div>
    </div>

    <div :class="overlayClass">
      <div class="page-overlay__content-container">
        <div v-if="overlayContent_confirm" class="page-overlay__content-header">
          Please Confirm...
        </div>
        <div
          v-if="overlayContent_processing"
          class="page-overlay__content-header text-primary"
        >
          Deleting upload...
        </div>
        <div
          v-if="overlayContent_error"
          class="page-overlay__content-header text-error"
        >
          There was a problem...
        </div>
        <hr color="#dddddd" />
        <b-spinner
          v-if="overlayContent_processing"
          label="Spinning"
          variant="primary"
        ></b-spinner>
        <div class="page-overlay__content-text">
          <p v-if="overlayContent_confirm" class="mb-3">Delete this upload?</p>
          <div
            v-if="overlayContent_confirm && deletedImage.imageThumbURL"
            class="image-card__image"
          >
            <img :src="deletedImage.imageThumbURL" alt="" />
          </div>
          <p v-if="overlayContent_processing" class="mb-4">
            Please wait a moment.
          </p>
          <div v-if="overlayContent_error">
            <p class="mb-2">{{ overlayContent_errorMsg }}</p>
            <p>Upload ID:</p>
            <p class="mb-4">{{ deletedImage.id }}</p>
          </div>
          <div class="page-overlay__content-footer">
            <div
              class="page-overlay__button-panel page-overlay__button-panel--2-col"
            >
              <div v-if="overlayContent_confirm">
                <button class="btn btn-secondary btn-sm" @click="hideOverlay">
                  No
                </button>
                <button class="btn btn-primary btn-sm" @click="doDelete">
                  Yes, delete
                </button>
              </div>
              <button
                v-if="overlayContent_error"
                class="btn btn-error btn-sm"
                @click="hideOverlay"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
console.log(85858);
// Get associated thumbnail file name for a given image filename
// and size:  g1.jpg -->> 150px thumb filename = g1_150x150.jpg
function thumbFilename(sourceFilename, size) {
  const fileNameSizeSegment = `_${size}x${size}`;
  const re = /(\.\w+$)/;
  return sourceFilename.replace(re, fileNameSizeSegment + '$1');
}

import ToggleControl from '@/components/layout/ToggleControl';
import CardImage from '@/components/cards/CardImage';
import { mapGetters } from 'vuex';

function sortByCreateTime(dataArray, sortOrder) {
  // If sortOrder is NOT des, set it to empty str (which will be set to default value of 'asc' in following line).
  // With these two lines, we force sortOrder to be one of 'asc' or 'des' no matter what the function is called with.
  sortOrder = sortOrder !== 'des' ? '' : sortOrder;
  sortOrder = sortOrder || 'asc';

  const sortFunction =
    sortOrder === 'asc'
      ? (a, b) => a.creTime - b.creTime
      : (a, b) => b.creTime - a.creTime;
  dataArray.sort(sortFunction);
  return dataArray;
}

export default {
  name: 'ImagesListPending',
  components: {
    ToggleControl,
    CardImage,
  },
  data: function () {
    return {
      // componentKey: 1,
      type: 'pending',
      showHeader: true,
      showButtonPanel: true,
      showProductsPanel: false,
      images: [],

      isDeleteOp: false,
      deletedImage: {}, // image selected for delete, i.e. image for which 'Delete Image' button was clicked. Same image obj passed in as prop to CardImage component
      pageOverlayHidden: true,
      overlayContent_confirm: true,
      overlayContent_processing: null,
      overlayContent_error: null,
      overlayContent_errorMsg: '',

      aboutPanelCollapsedText: 'Learn more...',
      aboutPanelOpenedText: '(close)',
      togglePaneCollapsed: true,
    };
  },
  watch: {
    // If the number of images in this view, e.g. 'pending' images, changes (e.g. one gets put in the 'selected' bin),
    // re-render the view to reflect this.
    numberImages: function () {
      // Rerender if change in number of images is NOT result of a delete operation; otherwise, this overrides the transtiion-group change
      // effect in the UI.
      if (!this.isDeleteOp) {
        this.rerenderView();
      }
    },
    // deletedImageId: function (imageId) {
    //   console.log('watched in listPending: imageId', imageId);
    //   this.deleteImage_UI(imageId);
    // },
    numberPending: function () {
      if (this.deletedImage.id) {
        this.deleteImage_UI(this.deletedImage.id);
      }
    },
    uploadInProgress: function (newBoolVal, oldBoolVal) {
      if (newBoolVal !== oldBoolVal) {
        // If val changed to false, that means an upload WAS in progress and now is NOT in progress...
        // so, if upload finished, rerender view
        if (!newBoolVal) {
          this.rerenderView();
        }
      }
    },
  },
  computed: {
    ...mapGetters('uploadTracker', [
      'imagesList',
      'numberPending',
      'imageCounts',
    ]),

    // ...mapGetters(['deletedImageId']),
    ...mapGetters(['uploadInProgress']),
    ...mapGetters('auth', ['authUser']),

    overlayClass: function () {
      return {
        'page-overlay': true,
        'page-overlay--hide': this.pageOverlayHidden,
      };
    },

    aboutPaneIconClass: function () {
      return {
        'fa-angle-down': this.togglePaneCollapsed,
        'fa-angle-up': !this.togglePaneCollapsed,
      };
    },
    aboutPanelText: function () {
      return this.togglePaneCollapsed
        ? this.aboutPanelCollapsedText
        : this.aboutPanelOpenedText;
    },

    maxNumUploads: function () {
      return this.imageCounts.maxNumPending || 0;
    },

    numberImages: function () {
      var submittedAndPending = [];
      var submitted = this.imagesList('Submitted');
      var pending = this.imagesList('Pending');
      if (submitted && pending) {
        submittedAndPending = [...submitted, ...pending];
        // submitted.forEach((i) => submittedAndPending.push(i));
        // pending.forEach((i) => submittedAndPending.push(i));
      }
      return submittedAndPending.length;
    },
  },

  methods: {
    justShown: function (isShowing) {
      console.log(isShowing);
    },
    showOverlay: function () {
      this.pageOverlayHidden = false;
      document.body.classList.add('page-overlay-showing');
    },
    hideOverlay: function () {
      this.pageOverlayHidden = true;
      document.body.classList.remove('page-overlay-showing');
      this.resetOverlay();
    },
    showConfirmDelete: function (imgObj) {
      this.deletedImage = imgObj;
      this.overlayContent_confirm = true;
      this.showOverlay();
    },
    showProcessing: function () {
      this.isDeleteOp = true;
      this.overlayContent_confirm = false;
      this.overlayContent_processing = true;
    },
    showError: function (errorMsg) {
      this.overlayContent_errorMsg = errorMsg;
      this.overlayContent_processing = false;
      this.overlayContent_error = true;
    },
    resetOverlay: function () {
      this.isDeleteOp = false;
      this.deletedImage = {};
      this.overlayContent_errorMsg = '';
      this.overlayContent_confirm = true;
      this.overlayContent_processing = false;
      this.overlayContent_error = false;
    },
    mockDelete: function (doResolve = true) {
      return new Promise((res, rej) => {
        setTimeout(function () {
          if (doResolve) {
            res(true);
          } else {
            // rej(new Error('Delete op is fucked up.'));
            rej(true);
          }
        }, 2000);
      });
    },
    doDelete: async function () {
      // console.log('hi from doDelete', this.deletedImage.id);
      // this.deleteImage_UI(this.deletedImage.id);
      try {
        //imageId += '-XXXX';
        var imageId = this.deletedImage.id; // + '-XXX';
        this.showProcessing();
        // await this.mockDelete(false);
        await this.$fapi.deleteUpload(imageId);
        this.hideOverlay();
        this.deleteImage_UI(this.deletedImage.id);
        // this.$store.dispatch('setDeletedImageId', imageId); // DON'T need ??
      } catch (err) {
        this.showError(err.message);
        console.log(err.message);
      }
    },
    rerenderView: function () {
      this.$parent.rerenderView();
    },
    deleteImage_UI: function (imageId) {
      var remainingImages = this.images.filter((img) => img.id !== imageId);
      // console.log(imageId);
      this.images = remainingImages;
    },
  },

  created: async function () {
    // Initialize state deletedImageId so that there will ALWAYS be a change detected on this property
    // i.e. this property is 'watched' here in this component to trigger removal of image card from DOM when
    // 'confirm delete' (in modal) is clicked.
    // this.$store.dispatch('setDeletedImageId', '');

    var submittedAndPendingImages = [];
    var submitted = this.imagesList('Submitted');
    var pending = this.imagesList('Pending');

    // If this route is current route, hitting browser refresh might have the two arrays NOT set yet
    if (submitted && pending) {
      submittedAndPendingImages = [...submitted, ...pending];
      // submitted.forEach((i) => submittedAndPendingImages.push(i));
      // pending.forEach((i) => submittedAndPendingImages.push(i));
    }

    this.images = sortByCreateTime(submittedAndPendingImages, 'des');

    // Add a UI image number (starting with 1) to each image.
    // See if thumbnail image exists for each image.
    // Doing this since if image was edited (replaced) and that replacement image
    // upload was interrupted/did not complete properly, the tracker may still have the prev image url AFTER THAT prev image
    // was deleted -- the result is a blank space in the CardImage where the thumbnail image should be and no way in the UI on the CardImage component to try to
    // fetch it. So, fetch each thumbnail img URL and if 'error' is the result, set docStats to something that's NOT 'ok' -- that will
    // trigger alert notice in the CardImage that something went wrong during the upload and that the user should delete this image, etc.
    var imageNum = 1;
    var thumbNailPath = 'dogimgs/' + this.authUser.uid + '/thumbs/';
    this.images.forEach(async (image) => {
      image.imageNum = imageNum;
      imageNum++;
      // console.log(image.imageFilename);
      var thumbnailImgUrl = await this.$fapi.getImageUrl(
        thumbNailPath + thumbFilename(image.imageFilename, 200)
      );
      if (thumbnailImgUrl === 'error') {
        image.docStatus = 'missingThumb';
      }
      // console.log(thumbnailImgUrl);
    });
  },
};
</script>

<style>
</style>